<template>
  <div class="app-inner">
    <!-- 车辆管理 -->
    <el-form :inline="true">
      <el-form-item label="车牌号">
        <el-input v-model="queryInfo.carNo" clearable placeholder="请输入车牌号"/>
      </el-form-item>
      <el-form-item label="当前状态">
        <!-- <el-input/> -->
        <el-select v-model="queryInfo.carStatus" clearable>
          <el-option
          v-for="item in carTypeList"
          :key="item.value"
          :value="item.value"
          :label="item.label"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
      <template #operate={row}>
        <el-button @click="add('edit', row.id)" type="text" size="small">编辑</el-button>
      </template>
    </table-list>
    <apply-dialog ref="Apply" @addSuccess="query"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import ApplyDialog from './applyDialog.vue'
import { carTypeList } from '@/utils/constants'
import { query } from '@/api/carInfo.js'
export default {
  data () {
    return {
      queryInfo: {
        carNo: '',
        carStatus: ''
      },
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        { label: '车牌', prop: 'carNo' },
        { label: '品牌', prop: 'brand' },
        { label: '载人量', prop: 'capacity' },
        { label: '当前状态', prop: 'carStatus' },
        { label: '备注', prop: 'reason', showOverflowTooltip: false },
        { label: '操作', prop: 'operate' }
      ],
      carTypeList: carTypeList
    }
  },
  components: {
    TableList,
    ApplyDialog
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      query({
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    add (type = 'new', id = '') {
      this.$refs.Apply.showDetails(type, id)
    }
  },
  mounted () {
    this.query()
  }
}
</script>
